import React, { Component } from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox'
import { AppConfiguration } from "read-appsettings-json"
import { IsEnglish } from '../../utils/language'
import { acceptTermsUse } from '../../actions/termsUse'
import Iframe from 'react-iframe'
import i18next from 'i18next'
import AlertAlgo from '../controls/AlertSnack'
import { withNamespaces } from 'react-i18next'
import Button from 'react-bootstrap-button-loader'
import * as redirect from '../../utils/redirect'
import * as storage from '../../utils/storage'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'

import styles from '../../styles/termsUse.module.css'

const useStyles = theme => ({
    appBarTitle: {
        position: 'relative',
    },
    appBar: {
        top: 'auto',
        bottom: 0,
        height: '125px!important',
        alignItems: 'center'
    },
    title: {
        fontSize: '20px'
    },
    checkbox: {
        '& > label': {
            display: 'table'
        }
    }
});

class TermsUse extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: '',
            contentTerm: '',
            acceptedTerms: false,
            isSaved: false,
            openSnack: false,
            message: '',
            typeAlert: ''
        }

        this.alert = React.createRef();
    }

    componentDidMount() {
        this.loadContent();
        this.resizeForm();
    }

    loadContent = () => {
        this.setState({
            title: `${i18next.t('helpOnline:title.termsUse-information')} - ${storage.getShowDateStatementTerms()}`,
            contentTerm: storage.getTermsUse()
        })
    }

    handleChange = (event) => {
        this.setState({ ...this.state, acceptedTerms: event.target.checked });
    }

    handleSave = async () => {
        if (!this.state.acceptedTerms) {
            this.alert.current.showMessageError(i18next.t('termsUse:notAccepted-error'));
        }
        else {

            acceptTermsUse().then(response => {
                if (response.status) {
                    redirect.home();
                }
            }).catch(error => {
                this.alert.current.showMessageError(i18next.t('error:generic-error'));
            });
        }
    }

    resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;

            const offSet = 185;

            const customHeight = height - offSet;
            document.querySelector('#termsUseFrame').style.height = `${customHeight}px`;
            document.querySelector('#termsUseFrame').style.overflowX = 'hidden';
        }, 1000);
    }

    handleCloseClick = () => {
        location = 'login';
    };


    render() {
        const { classes } = this.props;

        return (
            <div id="divTerms">
                <AppBar className={classes.appBarTitle}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={this.handleCloseClick} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.titleAppBar}>
                            <div id="page-wrap" className={classes.title}>{this.state.title}</div>
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div id="termsUseFrame" dangerouslySetInnerHTML={{ __html: this.state.contentTerm }}></div>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <div id="page-wrap" className={`${styles.descriptionTerms} ${classes.checkbox}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.acceptedTerms}
                                        onChange={this.handleChange}
                                        name="checkedTerms"
                                        variant="success"
                                    />
                                }
                                label={i18next.t('termsUse:acceptTerms')}
                            />
                            <div className={styles.button}>
                                <Button onClick={this.handleSave} loading={this.state.isSaved} variant="success">
                                    {i18next.t('buttons:save')}
                                </Button>
                            </div>
                        </div>
                    </Toolbar>
                </AppBar>
                <AlertAlgo ref={this.alert} />
            </div>
        );
    }
}

export default withNamespaces(['termsUse', 'buttons', 'error', 'helpOnline'], { wait: true })(withStyles(useStyles)(TermsUse));